import React from 'react';
import Blog from './components-home/Blog';
import Contact from './components-home/Contact';
import OurServices from './components-home/Feature';
import WhyChoseUs from './components-home/FeatureOne';
import FeatureTwo from './components-home/FeatureTwo';
import Heroarea from './components-home/Heroarea';
import Pricing from './components-home/Pricing';
import Testimonials from './components-home/Testimonials';
import Treatments from './components-home/Services';
import About from './components-home/Preface';
import Howitworks from './components-home/Howitworks';
import Screenshots from './components-home/Screenshots';


const Home = () => {

    return (
      <div>
      <Heroarea /><br></br>
      <About />
      <OurServices />
      <WhyChoseUs />
      {/* <FeatureTwo /> */}
      <Treatments />
      {/* <Howitworks /> */}
      {/* <Screenshots /> */}
      {/* <Pricing /> */}
      <Testimonials />
      {/* <Blog /> */}
      <Contact />
      </div>


    );
 
}



export default Home;
